/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Invite_Success1Inputs */

const en_usermanagement_invite_success1 = /** @type {(inputs: Usermanagement_Invite_Success1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitation sent successfully`)
};

/**
* | output |
* | --- |
* | "Invitation sent successfully" |
*
* @param {Usermanagement_Invite_Success1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_invite_success1 = /** @type {((inputs?: Usermanagement_Invite_Success1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Invite_Success1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_invite_success1(inputs)
});
export { usermanagement_invite_success1 as "userManagement_invite_success" }